import classNames from 'classnames/bind';
import { ReactNode } from 'react';

import { useDeletePriceChangesSubscription } from 'hooks/usePriceChangesSubscriptions';
import styles from '../index.module.scss';

const cx = classNames.bind(styles);

interface Props {
  children: ReactNode;
  searchKey: string;
  onCompleted(): void;
}

export default function DeleteButton({
  children,
  searchKey,
  onCompleted,
}: Props) {
  const deleteSubscription = useDeletePriceChangesSubscription(searchKey);

  function onDelete() {
    if (window.confirm('선택하신 가격 알림을 삭제하시겠습니까?')) {
      deleteSubscription({ onCompleted });
    }
  }

  return (
    <button type="button" className={cx('apply')} onClick={onDelete}>
      {children}
    </button>
  );
}
